// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"configurator-web-icon-button-wrapper","sm":"configurator-web-sm"};